module.exports = __webpack_public_path__ + "img/epgdefaultview.d089dabd.jpg";